import { defineStore } from 'pinia';
import { GAME_TYPES } from '../constants/gameTypes';

const games = {
  [GAME_TYPES.DIAMONDS]: {
    id: GAME_TYPES.DIAMONDS,
    displayName: 'Diamonds',
    symbol: '♦',
    input: 'units',
    points: -20,
    maxUnits: (playerCount) => (playerCount * 8) / 4
  },
  [GAME_TYPES.QUEENS]: {
    id: GAME_TYPES.QUEENS,
    displayName: 'Queens',
    symbol: 'Q',
    input: 'units',
    points: -25,
    maxUnits: () => 4
  },
  [GAME_TYPES.LEVATE]: {
    id: GAME_TYPES.LEVATE,
    displayName: 'Levate',
    symbol: 'L',
    input: 'units',
    points: -20,
    maxUnits: () => 8
  },
  [GAME_TYPES.TEN_OF_CLUBS]: {
    id: GAME_TYPES.TEN_OF_CLUBS,
    displayName: '10 of Clubs',
    symbol: '10♣',
    input: 'card',
    points: 100
  },
  [GAME_TYPES.KING_OF_HEARTS]: {
    id: GAME_TYPES.KING_OF_HEARTS,
    displayName: 'King of Hearts',
    symbol: 'K♥',
    input: 'card',
    points: -300
  },
  [GAME_TYPES.WHIST]: {
    id: GAME_TYPES.WHIST,
    displayName: 'Whist',
    symbol: 'W',
    input: 'units',
    points: 20,
    maxUnits: () => 8
  },
  [GAME_TYPES.RENTZ]: {
    id: GAME_TYPES.RENTZ,
    displayName: 'Rentz',
    symbol: 'R',
    input: 'order',
    points: 100,
    getPositionPoints(playerCount) {
      const points = [];
      for (let i = playerCount - 1; i >= 0; i--) {
        points.unshift(i === playerCount - 1 ? 0 : (playerCount - i - 1) * this.points);
      }
      return points;
    }
  },
  [GAME_TYPES.TOTALS]: {
    id: GAME_TYPES.TOTALS,
    displayName: 'Totals',
    symbol: 'Σ',
    input: 'totals'
  }
};

export const useGameConfigStore = defineStore('gameConfig', {
  state: () => ({ games })
});
